import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import CheckIcon from '@mui/icons-material/Check';
const AlertBorder = styled('div', {
    shouldForwardProp: prop => !['color', 'size', 'spacing', 'theme'].includes(prop.toString()),
}) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border: 4px solid;
  border-color: ${({ color }) => color};
  overflow: hidden;
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndex.appBar - 1};
  &:before {
    content: "";
    position: absolute;
    top: ${({ spacing }) => spacing};
    right: ${({ spacing }) => spacing};
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    background-color: ${({ color }) => color};
    transform: rotate(45deg);
  }
`;
const ItemAlertBorder = ({ variant, color, }) => {
    const theme = useTheme();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const alertOptions = {
        flag: {
            color: color ?? theme.palette.warning.main,
            size: '121px',
            spacing: '-60px',
        },
        check: {
            color: color ?? theme.palette.primary.main,
            size: '97px',
            spacing: '-49px',
        }
    };
    const iconColor = alertOptions[variant].color;
    const iconSize = alertOptions[variant].size;
    const iconSpacing = alertOptions[variant].spacing;
    return (_jsxs(AlertBorder, { className: "alert-border", color: iconColor, spacing: iconSpacing, size: iconSize, theme: theme, children: [(variant === 'flag') && (_jsx(FlagIcon, { sx: {
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    fontSize: '24px',
                    color: 'background.default',
                } })), (variant === 'check') && (_jsx(CheckIcon, { sx: {
                    position: 'absolute',
                    top: '9px',
                    right: '9px',
                    color: 'background.default',
                }, fontSize: 'small' }))] }));
};
export default ItemAlertBorder;
//# sourceMappingURL=index.js.map